export const INITIATE_GENESYS_SESSION = 'INITIATE_GENESYS_SESSION';
export const REFRESH_GENESYS_SESSION = 'REFRESH_GENESYS_SESSION';
export const DISCONNECT_GENESYS_SESSION = 'DISCONNECT_GENESYS_SESSION';
export const RESET_GENESYS_SESSION = 'RESET_GENESYS_SESSION';
export const SET_GENESYS_FILE_CONFIG = 'SET_GENESYS_FILE_CONFIG';
export const SET_API_ERROR = 'SET_API_ERROR';
export const GENESYS_RESET_STATE = 'GENESYS_RESET_STATE';